export default function Version() {
    return (
        <>
            <small>v1.34</small>
        </>
    )
}